<template>
  <div class="jet-radio-card" :class="{
    'is-active': isChecked,

    'is-disabled': disabled,

  }" @click="!disabled && changeHandler()">
    <label v-if="!tooltip" class="jet-radio-card__container">
      <!-- Input Radio (está escondido para ser aplicado o estilo de card) -->
      <input v-focus type="radio" :name="name" :value="value" :checked="isChecked" :disabled="disabled"
        class="jet-radio-card__input" @change="changeHandler">

      <!-- Card Content -->
      <div class="jet-radio-card__content"  :class="{ 'is-disabled': disabled }">
        <!-- Ícone SVG -->
        <SvgImage v-if="icon || isChecked" :icon="isChecked ? 'selected-option-check' : icon"
          class="jet-radio-card__icon" width="30" height="30" />
        <!-- Conteúdo -->
        <div class="jet-radio-card__text">
          <div class="jet-radio-card__text-content">
            <slot name="label" v-bind="{ label, isChecked, disabled }">
              <span :class="{ 'display-none': !label }" class="jet-radio-card__label">
                {{ label }}
              </span>
            </slot>

          </div>
          <AcceptedBrands v-if="value === 'jetcred'" class="jet-radio-card__brands" />
        </div>

      </div>

    </label>
    <!-- Tooltip -->
    <label v-else class="jet-radio-card__container">
      <Tooltip :text="tooltip">
           <!-- Input Radio (está escondido para ser aplicado o estilo de card) -->
      <input v-focus type="radio" :name="name" :value="value" :checked="isChecked" :disabled="disabled"
      class="jet-radio-card__input" @change="changeHandler">

    <!-- Card Content -->
    <div class="jet-radio-card__content"  :class="{ 'is-disabled': disabled }">
      <!-- Ícone SVG -->
      <SvgImage v-if="icon || isChecked" :icon="isChecked ? 'selected-option-check' : icon"
        class="jet-radio-card__icon" width="30" height="30" />
      <!-- Conteúdo -->
      <div class="jet-radio-card__text">
        <div class="jet-radio-card__text-content">
          <slot name="label" v-bind="{ label, isChecked, disabled }">
            <span :class="{ 'display-none': !label }" class="jet-radio-card__label">
              {{ label }}
            </span>
          </slot>

        </div>
        <AcceptedBrands v-if="value === 'jetcred'" class="jet-radio-card__brands" />
      </div>

    </div>
      </Tooltip>
    </label>


    <!-- Detalhes -->
    <div v-if="$slots.details || $scopedSlots.details" class="separator" />
    <slot v-if="$slots.details || $scopedSlots.details" name="details" v-bind="{ details }">
      <span :class="{ 'display-none': !details }" class="jet-radio-card__details">

        {{ details }}
      </span>
    </slot>
  </div>
</template>

<script>
import SvgImage from '~/components/General/SvgImage.vue';
import { focus } from '~/components/JetUi/utils/directives';
import AcceptedBrands from '../../atoms/AcceptedBrands/AcceptedBrands.vue';
import Tooltip from '../../atoms/Tooltip/Tooltip.vue';

export default {
  name: 'JetRadioCard',
  components: {
    SvgImage,
    AcceptedBrands,
    Tooltip
  },
  directives: {
    focus,
  },
  model: {
    prop: 'selected',
    event: 'change',
  },
  props: {
    disableAll: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    details: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  emits: ['change'],
  computed: {
    isChecked() {
      return this.value === this.selected;
    },
  },
  watch: {
    disableAll(newVal) {
      if (newVal) {
        this.$emit('input', '');
      }
    },
  },
  methods: {
    changeHandler() {
      this.$emit('input', this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "assets/themes/_variables.scss";

.tooltip-container {
  width: 100%;
}

.jet-radio-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid var(--card-border, #ddd);
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: border-color 0.3s, box-shadow 0.3s;
  background-color: var(--card-bg, #fff);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: 600px) {
    padding: 10px;
  }

  &:hover {
    border-color: $secondary-color;
  }

  &.is-active {
    border-color: $secondary-color !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
  }

  &.is-disabled {
    cursor: not-allowed;
    opacity: 0.6;

    &:hover {
      border-color: transparent;

    }
  }

  .jet-radio-card__container {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    cursor: pointer;
  }

  .jet-radio-card__input {
    display: none;
  }

  .jet-radio-card__content {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
  }

  .jet-radio-card__icon {
    width: 24px;
    height: 24px;
  }

  .jet-radio-card__text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .jet-radio-card__text-content {
      display: flex;
      flex-direction: column;
      gap: 4px;
      width: 100%;

      .jet-radio-card__label {
        font-size: 16px;
        font-weight: bold;
        color: var(--label-color, #333);
      }

      .jet-radio-card__details {
        font-size: 14px;
        color: var(--details-color, #666);
      }
    }

    .jet-radio-card__brands {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .jet-radio-card__container {
      display: flex;
      align-items: center;
      gap: 12px;
      width: 100%;
      cursor: pointer;
    }

    .jet-radio-card__input {
      display: none;
    }

    .jet-radio-card__content {
      display: flex;
      align-items: center;
      gap: 12px;
      width: 100%;

      &.is-disabled {
        cursor: not-allowed;

      }
    }

    .jet-radio-card__icon {
      width: 24px;
      height: 24px;
    }

    .jet-radio-card__text {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .jet-radio-card__text-content {
        display: flex;
        flex-direction: column;
        gap: 4px;
        width: 100%;

        .jet-radio-card__label {
          font-size: 16px;
          font-weight: bold;
          color: var(--label-color, #333);
        }

        .jet-radio-card__details {
          font-size: 14px;
          color: var(--details-color, #666);

        }
      }

      .jet-radio-card__brands {
        margin-left: auto;
        display: flex;
        align-items: center;
        gap: 8px;

      }
    }

  }
}

.separator {
  height: 1px;
  background: linear-gradient(to right, transparent, #ccc, transparent);
  margin-top: 20px;
  border: none;
  border-top: 1px solid #ccc;
  width: 100%;
}
</style>
